export default __webpack_public_path__ + "static/New Year Sleep Resolution-f289c6deb28218d88494b5184df5b732.jpg";